import React from 'react';
import './App.css';
import {
  Alert,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Box,
  Paper,
  Card,
  TextField,
  CardContent,
  CardMedia, List, ListItem, ListItemText, ListItemIcon
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';


function envAsString() {
  if (window.location.hostname.startsWith("rk-devbox1")) {
    return "dev"
  }

  else if (window.location.hostname.includes("omniinc.app")) {
    return "prod"
  }

  throw new Error(
    JSON.stringify(["envAsString not implemented for this environment",
      "hostname: " + window.location.hostname]))

}


const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#ff4081',
    },
  },
});

const features = ["unlimited whiteboards", "finger drawing", "color picker", "export to png"]

const LandingPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>ar.whiteboard</Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        {/* Hero Section */}
        <Box
          sx={{
            textAlign: 'center',
            py: 6,
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" gutterBottom>
            whats the idea?
          </Typography>
          <Typography variant="h6" gutterBottom>
            dynamic whiteboards, from the comfort of your virtual environment
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
              features
            </Typography>
            <List>
              {features.map((feature, index) => (

                <ListItem key={index}>
                  <ListItemIcon>
                    <CheckCircleIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={feature} />
                </ListItem>
              ))}
            </List>
          </Box>


          <Button variant="contained" color="primary" size="large"
            component={Link} to="/signup-beta">
            Sign Up for Beta
          </Button>
        </Box>

        {/* Features Section */}
        <Grid container spacing={4} sx={{ mt: 4 }}>
        </Grid>

        {/* Footer */}
        <Paper sx={{ mt: 6, py: 2, textAlign: 'center' }}>
          <Typography variant="body1">
            You can reach me at <a href="mailto:info@omniinc.app">info@omniinc.app</a>
          </Typography>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

interface SuccessAlertProps {
  enabled: boolean;
}

function SuccessAlert(props: SuccessAlertProps) {
  if (!props.enabled) {
    return null
  }

  return <Alert severity="success">We have your request, we&apos;ll be in touch shortly<br /><br/>Redirecting...</Alert>
}


type SubmitState = 'not-submitted' | 'submit-success'
 

function SignUpBeta() {

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");

  const [submitState, setSubmitState] =
    React.useState<SubmitState>('not-submitted')

  const navigate = useNavigate();

  const handleSubmit = React.useCallback(async (e: any) => {
    e.preventDefault();

    const submitUrl = () => {
      if (envAsString() === "dev") {
        return "http://rk-devbox1:4003"
      }

      else if (envAsString() === "prod") {
        return "https://receiver.omniinc.app"
      }
    }

    try {
      const res = await fetch(submitUrl() + "/receive", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          msg: "signup-beta", args: { name, email, env: envAsString() },
        }),
      })

      const data = await res.json();

      console.log('Success:', data);
      setSubmitState('submit-success')

      if (res.status == 200) {
        setTimeout(() => {
          navigate("/")
        }, 5000)

        console.log("succes submit beta form, redirecting to landing page")
      }

    } catch (err) {
      console.error('Error:', err);
    }



  }, [name, email]);



  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>ar.whiteboard</Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Box
          sx={{
            textAlign: 'center',
            py: 6,
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" gutterBottom>
            Sign Up for Beta
          </Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              maxWidth: 400,
              margin: '0 auto'
            }}
          >
            <TextField
              label="Name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
            />
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
            <SuccessAlert enabled={(submitState === "submit-success" ? true : false)} />
          </Box>

          <Typography variant="h6" gutterBottom>
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup-beta" element={<SignUpBeta />} />
        </Routes>
      </Router>
    </div>
  );
}


export default App;
